import React from 'react'

/**
 * Provide a function indicating the current mounted state of the component
 *
 * @return {Function} - a function returning true/false whether the component is mounted or not
 */
export default function useIsMounted() {
  const mounted = React.useRef(false)
  React.useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])
  return React.useCallback(() => mounted.current, [])
}
